import {
  Box,
  TextField,
  Button,
  FormControl,
  InputLabel,
  MenuItem,
  Grid,
  Select,
  Paper,
  Typography,
} from "@mui/material";
import CircularProgress from "@mui/material/CircularProgress";
import { useFormik } from "formik";
import ServerInfo from "../../services/API/ServerInfo.Api";
import * as yup from "yup";
import { isEmpty } from "lodash";
import { useQuery } from "react-query";
import { useState, SyntheticEvent } from "react";
import Snackbar from "@material-ui/core/Snackbar";
import MySnackbarContentWrapper from "../../MySnackbarContentWrapper";

const validationSchema = yup.object({
  group: yup.string().required("Group is required"),
  server: yup.string().required("Server is required"),
  password: yup
    .string()
    .min(8, "Password should be of minimum 8 characters length")
    .required("Password is required"),
});

const NewInstance = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [openSnackBar, setOpen] = useState(false);
  const [result, setResult] = useState("" as string);

  const formik = useFormik({
    initialValues: {
      group: "",
      server: "",
      password: "",
    },
    validationSchema: validationSchema,
    onSubmit: async (values) => {
      setIsLoading(true);

      await ServerInfo.setNewInstance(values)
        .then((response) => {
          formik.resetForm();
          setIsLoading(false);
          setOpen(true);
          setResult("success");
        })
        .catch((err) => {
          setResult("failure");
          setIsLoading(false);
          setOpen(true);
        });
    },
  });

  //---------------------- useQuery for Data-Fetching ----------------------//
  const { isFetched, data: serversList } = useQuery(
    ["GetServersByGroup", formik.values.group],
    () => ServerInfo.getServersByGroup({ group: formik.values.group }),
    {
      initialData: [],
      keepPreviousData: true,
      enabled: !isEmpty(formik.values.group),
    }
  );

  const handleClose = (event?: SyntheticEvent, reason?: string) => {
    if (reason === "clickaway") {
      return;
    }
    setOpen(false);
  };

  return (
    <>
      <Grid container>
        <Grid item md={4} xs={12} />

        <Grid item md={4} xs={12}>
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              marginTop: "20px",
            }}
          >
            <Typography variant="h5">Set New Instance</Typography>
          </Box>

          <Paper sx={{ marginTop: "20px", padding: "40px" }}>
            <Box>
              <form autoComplete="off" onSubmit={formik.handleSubmit}>
                <Grid container spacing={3}>
                  <Grid item xs={12}>
                    <FormControl fullWidth>
                      <InputLabel>Select Group</InputLabel>
                      <Select
                        name="group"
                        value={formik.values.group}
                        label="Select Group"
                        onChange={formik.handleChange}
                        error={
                          formik.touched.group && Boolean(formik.errors.group)
                        }
                      >
                        <MenuItem value={"IdealWVD"}>IdealWVD</MenuItem>
                        <MenuItem value={"InfinityWVD"}>InfinityWVD</MenuItem>
                        <MenuItem value={"CSAR-AZMST"}>CSAR-AZMST</MenuItem>
                        <MenuItem value={"CSAR-AZPST"}>CSAR-AZPST</MenuItem>
                        <MenuItem value={"CSAR-AZEST"}>CSAR-AZEST</MenuItem>
                        <MenuItem value={"CSAR-AZCST"}>CSAR-AZCST</MenuItem>
                      </Select>
                    </FormControl>
                    {formik.touched.group && formik.errors.group ? (
                      <div style={{ fontSize: "11px", color: "red" }}>
                        {formik.errors.group}
                      </div>
                    ) : null}
                  </Grid>

                  <Grid item xs={12}>
                    <FormControl fullWidth>
                      <InputLabel>Select Server</InputLabel>
                      <Select
                        name="server"
                        value={formik.values.server}
                        label="Select Server"
                        onChange={formik.handleChange}
                        error={
                          formik.touched.server && Boolean(formik.errors.server)
                        }
                      >
                        {serversList &&
                          serversList.map((Server: any) => (
                            <MenuItem key={Server.id} value={Server.server}>
                              {Server.server}
                            </MenuItem>
                          ))}
                      </Select>
                    </FormControl>
                    {formik.touched.server && formik.errors.server ? (
                      <div style={{ fontSize: "11px", color: "red" }}>
                        {formik.errors.server}
                      </div>
                    ) : null}
                  </Grid>

                  <Grid item xs={12}>
                    <TextField
                      fullWidth
                      name="password"
                      label="Password"
                      type="password"
                      value={formik.values.password}
                      onChange={formik.handleChange}
                      error={
                        formik.touched.password &&
                        Boolean(formik.errors.password)
                      }
                      helperText={
                        formik.touched.password && formik.errors.password
                      }
                    />
                  </Grid>

                  <Grid item xs={12}>
                    {isLoading ? (
                      <Button
                        color="primary"
                        variant="contained"
                        fullWidth
                        type="submit"
                        endIcon={<CircularProgress color="inherit" size={20} />}
                      >
                        Submit
                      </Button>
                    ) : (
                      <Button
                        color="primary"
                        variant="contained"
                        fullWidth
                        type="submit"
                      >
                        Submit
                      </Button>
                    )}
                  </Grid>
                </Grid>
              </form>
            </Box>
          </Paper>
        </Grid>

        <Grid item md={4} xs={12} />
      </Grid>

      <Snackbar
        anchorOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
        open={openSnackBar}
        autoHideDuration={5000}
        onClose={handleClose}
      >
        {result === "success" ? (
          <MySnackbarContentWrapper
            onClose={handleClose}
            variant="success"
            message="Instance Added Successfully."
          />
        ) : (
          <MySnackbarContentWrapper
            onClose={handleClose}
            variant="error"
            message="Something went wrong."
          />
        )}
      </Snackbar>
    </>
  );
};

export default NewInstance;
